export enum RouteConstants {
  UserManagement = 'user-management',
  AddUsers = 'add-users',
  EditUser = 'edit-user/:userId',
  AdminPagePath = '/admin',
}
